import { CircularProgress, Grid } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getSupplierCustomerInvoiceApi } from '../../../redux/Supplier/action';
import { formatCurrency } from '../../../utility/helpers/displayHelper';
import '../SupplierProfile/SupplierProfile.css';
import Cards from './Cards';

export const SupplierICustomerInvoiceTab = ({ supplierId }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const supplierInvoiceList = useSelector((state) => state?.supplier?.supplierInvoiceData);

    const fetchSupplierInvoiceList = async () => {
        try {
            setIsLoading(true);
            await dispatch(getSupplierCustomerInvoiceApi({ supplierId }));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (supplierId) {
            fetchSupplierInvoiceList();
        }
    }, [supplierId]);

    if (isLoading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: 350 }}>
                <CircularProgress />
            </Grid>
        );
    }

    if (!supplierInvoiceList?.data?.length) {
        return null;
    }

    return (
        <div>
            <Grid container spacing={3}>
                {supplierInvoiceList.data.map((invoice, index) => (
                    <Grid item container xs={12} sm={12} md={6} lg={12} xl={6} key={invoice?._id || index}>
                        {console.log('invoiceinvoiceinvoice', invoice)}
                        <Cards
                            navigate={navigate}
                            navigateUrl={invoice?.isEmailSent ? `/invoice/sent/${invoice?._id}` : `/invoice/finalized/${invoice?._id}`}
                            activeTab="invoice"
                            date={invoice?.createdAt ? dayjs(invoice?.createdAt).format('MMM D, YYYY') : ' - '}
                            customerName={`${invoice?.customer?.firstName || 'John'} ${invoice?.customer?.lastName || 'Doe'}`}
                            vehicle={`${invoice?.vehicle?.year || ''} ${invoice?.vehicle?.vehicleMake?.name || ''} ${
                                invoice?.vehicle?.vehicleModel?.name || ''
                            } ${invoice?.vehicle?.vehicleModelTrim?.name || ''}`}
                            chipNumber={invoice?.invoiceNumber || ''}
                            amount={invoice?.Total ? formatCurrency(invoice?.Total) : '$0.00'}
                        />
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default SupplierICustomerInvoiceTab;
